var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sc-card',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.initialRequest),expression:"!initialRequest"}],attrs:{"title":_vm.$t(`events-log`)}},[_c('div',{class:`sc-events-log ${_vm.type}`},[(_vm.eventsData)?_c('sc-events-log-list',{attrs:{"events-data":_vm.eventsData,"type":_vm.type}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }